import React, { useEffect, useState } from "react";
import { Button, Form, Card, Table, Spinner } from "react-bootstrap";
import Layout from "../../layouts/default";
import { FaPhoneAlt, FaUpload, FaDownload } from "react-icons/fa";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
    smartConnectAddDIDs,
    SmartConnectFetchDids,
    resetUploadResult,
} from "../../store/slices/smartConnect/smartConnectDids";
import SmartPagination from "../Report/EmailCampaignRunReport/DynamicSmartPagination";
import { hasPermission } from "../../services/utils";
import { PERMISSIONS } from "../../contants/permission";

function SmartConnectAddDids() {
    const dispatch = useDispatch();
    const [file, setFile] = useState(null);
    const [page, setPage] = useState(1);
    const [filters, setFilters] = useState({
        did_number: "",
        status: "remaining",
        cq_agent_id: "",
        agent_type: "",
    });


    const LIMIT = 10;

    const {
        data = [],
        loading,
        uploading,
        uploadResult,
        error,
        pagination = {},
    } = useSelector((state) => state.smartConnectDIDsReducer);

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const fetchDids = (pageNo = page, overrideFilters) => {
        dispatch(
            SmartConnectFetchDids({
                limit: LIMIT,
                skip: (pageNo - 1) * LIMIT,
                filters: overrideFilters ?? {
                    did_number: filters.did_number || undefined,
                    status: filters.status || "remaining",
                    cq_agent_id: filters.cq_agent_id || undefined,
                    agent_type: filters.agent_type || undefined,
                },
            })
        );
    };


    const handleSubmit = async () => {
        if (!file) {
            toast.error("Please upload a CSV file");
            return;
        }

        const formData = new FormData();
        formData.append("file", file);

        try {
            await dispatch(smartConnectAddDIDs(formData)).unwrap();
            setFile(null);
            setPage(1);
            fetchDids(1);
        } catch (err) {
            console.log("Error in submit : ", err);
        }
    };

    const handleDownloadSample = () => {
        const csvContent = `DIDs (10 Digit Number)
97******77`;

        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "sample_dids.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    useEffect(() => {
        fetchDids(1);
    }, []);

    useEffect(() => {
        fetchDids(page);
    }, [page]);

    useEffect(() => {
        if (uploadResult?.success) {
            toast.success(uploadResult.message);
            dispatch(resetUploadResult());
        }
    }, [uploadResult]);

    useEffect(() => {
        if (error) toast.error(error);
    }, [error]);

    const showValue = (val) => {
        if (val === null || val === undefined || val === "") return "NA";
        return val;
    };

    const formatToIST = (date) => {
        if (!date) return "NA";

        try {
            return new Date(date).toLocaleString("en-IN", {
                timeZone: "Asia/Kolkata",
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: true,
            });
        } catch {
            return "NA";
        }
    };

    const handleReset = () => {

        setFilters({
            did_number: "",
            status: "remaining",
            cq_agent_id: "",
            agent_type: "",
        });
        setPage(1);
        fetchDids(1, {
            did_number: "",
            status: "remaining",
            cq_agent_id: "",
            agent_type: "",
        });

    }


    return (
        <Layout>
            {/* Header */}
            {
                hasPermission(PERMISSIONS.SMART_CONNECT.CREATE) && <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="d-flex align-items-center gap-2">
                        <FaPhoneAlt size={22} />
                        <h3 className="m-0">Add DIDs</h3>
                    </div>

                    <Button variant="outline-primary" onClick={handleDownloadSample}>
                        <FaDownload className="me-1" />
                        Download Sample CSV
                    </Button>
                </div>
            }

            {/* Upload */}
            {
                hasPermission(PERMISSIONS.SMART_CONNECT.CREATE) && <Card className="mb-4">
                    <Card.Body>
                        <Form>
                            <Form.Group>
                                <Form.Label>Upload DIDs CSV File</Form.Label>
                                <Form.Control type="file" accept=".csv" onChange={handleFileChange} />
                                <Form.Text className="text-muted">
                                    CSV must contain a column <b>DIDs</b> with one DID per row.
                                </Form.Text>
                            </Form.Group>

                            <div className="mt-3">
                                {
                                    hasPermission(PERMISSIONS.SMART_CONNECT.CREATE) && <Button onClick={handleSubmit} disabled={uploading}>
                                        {uploading ? (
                                            <Spinner size="sm" />
                                        ) : (
                                            <>
                                                <FaUpload className="me-1" />
                                                Submit DIDs
                                            </>
                                        )}
                                    </Button>
                                }
                            </div>
                        </Form>
                    </Card.Body>
                </Card>
            }

            {/* Filters */}
            <Card className="mb-4">
                <Card.Body>
                    <Form>
                        <div className="d-flex flex-wrap gap-3 align-items-end">
                            <Form.Group>
                                <Form.Label>DID</Form.Label>
                                <Form.Control
                                    placeholder="Search DID"
                                    value={filters.did_number}
                                    onChange={(e) =>
                                        setFilters({ ...filters, did_number: e.target.value })
                                    }
                                />
                            </Form.Group>

                            {/* <Form.Group>
                                <Form.Label>Status</Form.Label>
                                <Form.Select
                                    value={filters.status}
                                    onChange={(e) =>
                                        setFilters({ ...filters, status: e.target.value })
                                    }
                                >
                                    <option value="">All</option>
                                    <option value="REMAINING">REMAINING</option>
                                    <option value="ACTIVE">ACTIVE</option>
                                    <option value="SPAMMED">SPAMMED</option>
                                    <option value="COMPLAINT">COMPLAINT</option>
                                    <option value="RESERVED">RESERVED</option>
                                </Form.Select>
                            </Form.Group> */}

                            {/* <Form.Group>
                                <Form.Label>Agent ID</Form.Label>
                                <Form.Control
                                    placeholder="Agent ID"
                                    value={filters.cq_agent_id}
                                    onChange={(e) =>
                                        setFilters({ ...filters, cq_agent_id: e.target.value })
                                    }
                                />
                            </Form.Group>

                            <Form.Group>
                                <Form.Label>Agent Type</Form.Label>
                                <Form.Select
                                    value={filters.agent_type}
                                    onChange={(e) =>
                                        setFilters({ ...filters, agent_type: e.target.value })
                                    }
                                >
                                    <option value="">All</option>
                                    <option value="CSM">CSM</option>
                                    <option value="SALES_SETTLEMENT">SALES / SETTLEMENT</option>
                                </Form.Select>
                            </Form.Group> */}

                            <div className="d-flex gap-2">
                                <Button
                                    onClick={() => {
                                        setPage(1);
                                        fetchDids(1);
                                    }}
                                >
                                    Apply Filter
                                </Button>

                                <Button
                                    variant="outline-secondary"
                                    onClick={handleReset}
                                >
                                    Reset
                                </Button>
                            </div>
                        </div>
                    </Form>
                </Card.Body>
            </Card>


            {/* DID List */}
            <Card>
                <Card.Body>
                    <h5 className="mb-3">DID List</h5>

                    <Table bordered hover responsive>
                        <thead className="table-light">
                            <tr>
                                <th>#</th>
                                <th>DID NUMBER</th>
                                <th>STATUS</th>
                                <th>CREATED BY</th>
                                <th>CREATED AT</th>
                            </tr>
                        </thead>

                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan={8} className="text-center">
                                        <Spinner size="sm" />
                                    </td>
                                </tr>
                            ) : data.length === 0 ? (
                                <tr>
                                    <td colSpan={8} className="text-center text-muted">
                                        No DIDs found
                                    </td>
                                </tr>
                            ) : (
                                data.map((did, index) => (
                                    <tr key={did.id}>
                                        <td>{(page - 1) * LIMIT + index + 1}</td>
                                        <td>{showValue(did.did_number)}</td>
                                        <td>{showValue(did.status)}</td>
                                        <td>{showValue(did.createdByUser?.name)}</td>
                                        <td>{formatToIST(did.created_at)}</td>
                                    </tr>
                                ))
                            )}
                        </tbody>

                    </Table>

                    {/* Pagination */}
                    {pagination?.totalPages > 1 && (
                        <SmartPagination
                            currentPage={page}
                            totalPages={pagination.totalPages}
                            onPageChange={setPage}
                        />
                    )}
                </Card.Body>
            </Card>
        </Layout>
    );
}

export default SmartConnectAddDids;
